import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // No `lng` here — let LanguageDetector decide
    supportedLngs: ['zh', 'en', 'ja'],
    // Allow zh-TW / zh-CN / en-US / ja-JP … to match zh / en / ja
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    detection: {
      // Check localStorage first, then browser navigator
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'tabifoto_lang',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
